/**
 * hoverRelated
 */
import { breakpoint, containerID } from '@/_modules/utils/variables';
import {TweenMax, Cubic, Back} from 'gsap/all';

export default class hoverRelated {
  /**
   * コンストラクタ
   *
   * @el DOM要素
   * @index ID番号（連番）
   * @center 子
   */
  constructor(el, index, center, position, isHover) {
    // クラス名
    this.name = 'hoverRelated';
    this.el = el;
    this.index = index;
    this.center = center;
    this.position = position;
    this.counter = 0;
    this.isShow = false;
    this.isOver = false;
    this.isPlaying = false;
    this.isHover = isHover;

    // getTotalLength非対応ブラウザのため
    this.len = 721.8457641601562;
    //this.len = this.hoverCircle[0].getTotalLength();

    this.init();
  }

  /**
   * 初期
   */
  init() {
    if (this.isHover) {
      this.el.addEventListener('mouseenter', this.onHover.bind(this));
      this.el.addEventListener('mouseleave', this.onHover.bind(this));
    }

    this.bg = this.el.querySelector('.js-hoverBg');
    this.photo = this.el.querySelector('.js-hoverPhoto');

    this.hoverCircleMain = this.bg.querySelector('.js-hoverBgMain circle');

    this.hoverLine = this.bg.querySelectorAll('.js-hoverBgHover');
    this.hoverCircle = [
      this.hoverLine[0].querySelector('circle'),
      this.hoverLine[1].querySelector('circle')
    ];

    if (this.position) {
      // parent
      TweenMax.set(this.el, {
        x: this.position.x,
        y: this.position.y,
        opacity: 0,
        visibility: 'hidden'
      });
    } else {
      // child
      TweenMax.set(this.el, {
        x: this.center.x,
        y: this.center.y,
        opacity: 0,
        visibility: 'hidden'
      });
    }

    this.resetCircle();
  }

  start(isChild, position) {
    if (isChild) {
      // 子
      this.position = position;

      TweenMax.fromTo(this.el, 0.4, {
        visibility: 'visible',
        x: this.center.x,
        y: this.center.y
      }, {
        delay: 0.02 * this.index,
        x: position.x,
        y: position.y,
        ease: Back.easeOut.config(1.0)
      });

      TweenMax.to(this.el, 0.3, {
        delay: (0.02 * this.index) + 0.05,
        opacity: 1,
        ease: Cubic.easeOut
      });

      //this.showCircleOnce(isChild);

    } else {
      // 親
      TweenMax.fromTo(this.el, 0.5, {
        visibility: 'visible',
      }, {
        opacity: 1,
        ease: Cubic.easeOut
      });

      this.showCircleOnce();
    }
  }

  hide() {
    TweenMax.to(this.el, 0.4, {
      //x: this.center.x * 0.5,
      //y: this.center.y * 0.5,
      opacity: 0,
      ease: Cubic.easeOut,
      onComplete: this.hideComp.bind(this)
    });
  }

  hideComp() {
    TweenMax.set(this.el, {visibility: 'hidden'});
  }

  resize(center, position) {
    this.center = center;
    this.position = position;

    if (this.position) {
      // child
      TweenMax.set(this.el, {
        x: this.position.x,
        y: this.position.y
      });
    } else {
      // parent
      TweenMax.set(this.el, {
        x: this.center.x,
        y: this.center.y
      });
    }
  }

  // マウスオーバー設定 /////
  onHover(e) {
    if (e.type === 'mouseenter'|| e.type === 'touchstart') {
      this.over(e);
    } else if (e.type === 'mouseleave'|| e.type === 'touchend'|| e.type === 'touchcancel') {
      this.out(e);
    } else if (e.type === 'mousemove'|| e.type === 'touchmove') {
      //this.mousemove(e);
    }
  }

  over(e) {
    this.isOver = true;
    if (!this.isPlaying) {
      this.startRollOver();
    }
  }

  out(e) {
    this.isOver = false;
    if (!this.isPlaying) {
      this.startRollOut();
    }
  }

  startRollOver() {
    this.isPlaying = true;

    this.showCircle(this.completeRollOver.bind(this));
  }

  completeRollOver() {
    this.isPlaying = false;
    if(!this.isOver) {
      this.startRollOut();
    }
  }

  startRollOut() {
    this.isPlaying = true;

    this.hideCircle(this.completeRollOut.bind(this));
  }

  completeRollOut() {
    this.isPlaying = false;
    if(this.isOver) {
      this.startRollOver();
    }
  }

  // 周りの円の設定 /////
  showCircle(callback) {
    TweenMax.fromTo(this.hoverCircleMain, 0.4, {
      'stroke-dashoffset': this.len,
    },{
      'stroke-dashoffset': 0,
      ease: Cubic.easeOut
    });

    TweenMax.set(this.hoverLine[0], {
      rotation: -90
    });

    TweenMax.to(this.hoverCircle[0], 0.4, {
      delay: 0.1,
      'stroke-dashoffset': this.len * 0.75,
      ease: Cubic.easeOut
    });

    TweenMax.set(this.hoverLine[1], {
      rotation: 90
    });

    TweenMax.to(this.hoverCircle[1], 0.4, {
      delay: 0.1,
      'stroke-dashoffset': this.len * 0.75,
      ease: Cubic.easeOut,
      onComplete: callback
    });
  }

  showCircleOnce(isChild) {
    if (isChild) {
      TweenMax.to(this.hoverCircleMain, 0.6, {
        delay: this.index * 0.1,
        'stroke-dashoffset': -this.len,
        ease: Cubic.easeInOut
      });
    } else {
      TweenMax.to(this.hoverCircleMain, 0.6, {
        delay: this.index * 0.1,
        'stroke-dashoffset': 0,
        ease: Cubic.easeInOut
      });

      TweenMax.to(this.hoverCircle[0], 0.6, {
        delay: 0.1 + (this.index * 0.1),
        'stroke-dashoffset': this.len * 0.75,
        ease: Cubic.easeOut
      });

      TweenMax.to(this.hoverCircle[1], 0.6, {
        delay: 0.1 + (this.index * 0.1),
        'stroke-dashoffset': this.len * 0.75,
        ease: Cubic.easeOut
      });
    }
  }

  hideCircle(callback) {
    TweenMax.to(this.hoverCircleMain, 0.4,  {
      'stroke-dashoffset': -this.len,
      ease: Cubic.easeOut
    });

    TweenMax.to(this.hoverLine[0], 0.4, {
      rotation: 0,
      ease: Cubic.easeOut
    });

    TweenMax.to(this.hoverCircle[0], 0.4, {
      'stroke-dashoffset': this.len,
      ease: Cubic.easeOut
    });

    TweenMax.to(this.hoverLine[1], 0.4,  {
      rotation: 180,
      ease: Cubic.easeOut
    });

    TweenMax.to(this.hoverCircle[1], 0.4,  {
      'stroke-dashoffset': this.len,
      onComplete: callback
    });
  }

  resetCircle() {
    // main
    TweenMax.set(this.hoverCircleMain, {
      'stroke-dashoffset': this.len,
      'stroke-dasharray': this.len
    });

    // 1
    TweenMax.set(this.hoverLine[0], {
      rotation: -90
    });

    TweenMax.set(this.hoverCircle[0], {
      //'stroke-dashoffset': len * 0.75,
      'stroke-dashoffset': this.len,
      'stroke-dasharray': this.len
    });

    // 2
    TweenMax.set(this.hoverLine[1], {
      rotation: 90
    });

    TweenMax.set(this.hoverCircle[1], {
      //'stroke-dashoffset': len * 0.75,
      'stroke-dashoffset': this.len,
      'stroke-dasharray': this.len
    });
  }
}